import React, {useState} from 'react';
import { Modal, Button } from 'antd';

interface ReverseButtonProps {
    api: any;
    node: any;
    onReverseButton: (reverseRow: number) => void;
}

const ReverseButtonComponent: React.FC<ReverseButtonProps> = ({ api, node, onReverseButton }) => {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        onReverseButton(node.rowIndex)
        setIsModalOpen(false);

    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onButtonClick = () => {
        showModal()
    };

    return (
        <>
            <button
            onClick={onButtonClick}
            className=''
            style={{
                width: '20px',
                height: '20px',
                border: 'none',
                padding: 0,
                background: 'transparent',
                borderRadius: 0,
            }}
            >
                <img src="/images/reverse.png" alt="Delete" style={{ width: '15px', height: '15px' }} />
            </button>
            <Modal 
                title="Reverse Filing" 
                open={isModalOpen}
                onOk={handleOk} 
                onCancel={handleCancel}
                width={400}
                footer={[
                    <Button key="ok" size='small' style={{width: 80, fontSize: 12, backgroundColor: 'green', color: 'white'}} onClick={handleOk}>
                      Yes
                    </Button>,
                    <Button key="cancel"  size='small' style={{width: 80, fontSize: 12, backgroundColor: 'green', color: 'white'}} onClick={handleCancel}>
                      No
                    </Button>,
                  ]}
            >
                <p>Are you sure you want to reverse (create an offsetting transaction) the filing for policy {node.data.policynumber}?</p>
            </Modal>
        </>    
    );
};

export default ReverseButtonComponent;